export default "__VITE_ASSET__2oU6v4fB__"